import { AfterViewInit, Component, OnInit } from "@angular/core";

declare var hbspt: any;
@Component({
  selector: "app-navbar-support-hubspot",
  templateUrl: "./navbar-support-hubspot.component.html",
  styleUrls: ["./navbar-support-hubspot.component.scss"],
})
export class NavbarSupportHubspotComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    hbspt.forms.create({
      region: "na1",
      portalId: "6309031",
      formId: "33799ef8-6a3b-4f38-96f0-28971fe2b904",
      target: "#hubspotForm",
    });
  }
}
